export default __webpack_public_path__ + "images/CAT.6810de0.png";